import React, { CSSProperties } from "react";
import { TextEl, IELinkState } from "./index";
import * as Helpers from "./base/Helpers";

class ELink extends TextEl<HTMLAnchorElement, IELinkState> {
    _elRef: React.RefObject<HTMLAnchorElement> = React.createRef();

    getStyles = (): CSSProperties => {
        let styles: CSSProperties = {
            backgroundColor: "transparent",
        };

        if (this.props.Brand) {
            const { Brand } = this.props;

            styles = {
                backgroundColor: "transparent",
                color: Brand.linkColor,
                fontFamily: Brand.fontFamily,
                textDecoration: "none",
                textAlign: "left",
                verticalAlign: "baseline",
                lineHeight: this.__unitSize(
                    Helpers.getLineHeightFromFontSize(Brand.documentFontSize)
                ),
                borderBottom: 0,
                fontSize: this.__unitSize(Brand.documentFontSize),
            };
        }

        if (this.props.size) {
            styles.fontSize = this.__unitSize(this.props.size);
            styles.lineHeight = this.__unitSize(
                Helpers.getLineHeightFromFontSize(this.props.size)
            );
        }

        if (this.props.color) {
            styles.color = this.props.color;
        }

        return styles;
    };

    componentDidMount() {
        const el = this._elRef.current;

        if (el) {
            el.style.setProperty("text-decoration", "none");
            el.style.setProperty("text-decoration", "none", "important");
            el.style.setProperty("color", this.getFontColor(), "important");
        }
    }

    getFontColor() {
        if (this.props.color) {
            return this.props.color;
        }
        if (this.props.Brand) {
            return this.props.Brand.fontColor;
        }

        return "#2c2c2c";
    }

    render(): JSX.Element {
        const { Brand, ...rest } = this.props;
        return (
            <a
                ref={this._elRef}
                border={0}
                target="_blank"
                style={this.__setStyle(this.getStyles())}
                {...rest}
            >
                <span style={this.__setStyle(this.getStyles())}>
                    {this.props.children}
                </span>
            </a>
        );
    }
}

export { ELink };
